<template>
  <div class="allCampaign">
    <div class="container-router">
      <div class="title">
        <h1 class="medium-title">All Campaign</h1>
        <ul class="title__menu">
          <router-link tag="li" :to="{name: 'advertiserstatic'}">Static Advertising</router-link>
          <!-- <router-link tag="li" :to="{name: 'advertiserdigitalscreen'}">Digital Screen</router-link> -->
          <router-link tag="li" :to="{name: 'advertiserbus'}">Transit Advertising</router-link>
        </ul>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import TransactionItem from '@/views/Transaction/TransactionItem'
import SideBar from '@/components/SideBar/Desktop'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters } from 'vuex';

export default {
  name: 'adx-',
  components: {
    'transaction-item': TransactionItem,
    "adx-sidebar": SideBar,
    'adx-loading': Loading,
    'adx-pagination': Pagination
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      currentPage: 1,
      maxPage: 1,
    }
  },
  computed: {
    ...mapGetters({
      user: 'account',
    }),
    // isStaticGroup(){
    //   const hasOpsSpvPermisson = this.user.groups.includes('OpsSupervisor')
    //   const hasGAPermission = this.user.groups.includes('GA')
    //   const isSuperuser = this.user.isSuperuser
    //   return hasOpsSpvPermisson || hasGAPermission || isSuperuser
    // }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
